import {faCog, faCopy, faHome} from "@fortawesome/free-solid-svg-icons";

export default {
    id: 'MEDCAL_RX_HEADER',
    responsive: {
        displayIcon: {
            id: 'MEDCAL_RX_RESPONSIVE_NAV',
            position: 'left'
        }
    },
    navBars: {
        top: {
            contact: {
                id: 'MEDCAL_NAV_TOP_CONTACT_US'
            },
            user: {
                id: 'MEDCAL_NAV_TOP_USER'
            },
            npi: {
                id: 'MEDCAL_NAV_TOP_NPI'
            },
            googleTranslate: {
                id: 'MEDCAL_RX_GOOGLE_TRANSLATE'
            },
            home: {
                text: 'Home',
                to: '/',
                id: 'MEDCAL_RX_NAV_TOP_HOME'
            }
        },
        bottom: {
            home: {
                icon: faHome,
                text: 'Home',
                to: '/',
                id: 'MEDCAL_RX_NAV_BOTTOM_HOME'
            },
            tools: {
                icon: faCog,
                text: 'Tools',
                to: '/tools',
                id: 'MEDCAL_RX_NAV_BOTTOM_TOOLS'
            },
            resources: {
                icon: faCopy,
                text: 'Resources',
                to: '/resources',
                id: 'MEDCAL_RX_NAV_BOTTOM_RESOURCES'
            },
            logout: {
                text: 'Log Out',
                to: '',
                id: 'MEDCAL_RX_NAV_BOTTOM_LOGOUT'
            }
        }
    },
    caLogo: {
        id: 'MEDCAL_RX_CA_LOGO',
        text: 'Logo for California'
    }
}
